import React, { useState } from 'react'
import { baseUrl } from '../config';
import { useNavigate, useParams } from 'react-router';
import { Link } from 'react-router-dom';

const VerifyEmail = () => {
  const {id}=useParams();
  const navigate = useNavigate(); // Create a navigate function
    const [code, setCode] = useState('');
    const [responseMessage, setResponseMessage] = useState(''); // New state variable for the response message
    const [submit, setSubmit] = useState(false);
    const handleCodeChange = (e) => {
        setCode(e.target.value);
      };
    

      
    const handleSubmit = async (e) => {
        setSubmit(true);
        e.preventDefault();
    
        var raw = JSON.stringify({
          token: code,
          user_id:id
        });
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
    
        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow"
        };
        fetch(`${baseUrl}/api/verify/email`, requestOptions)
          .then((response) => response.text())
          .then((result) => {
            console.log(result)
    
              result=JSON.parse(result);
              if(result.status==200){
               alert(result.message);
                setResponseMessage(result.message)
        navigate('/login');
            
              }
              else
              {
                setResponseMessage(result.message)
              }
              setSubmit(false);
          })
          .catch((error) => {console.log("error", error);setSubmit(false);});
    
      };
      const ResendEmail = async () => {
    
        var raw = JSON.stringify({
          user_id:id
        });
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
    
        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow"
        };
        fetch(`${baseUrl}/api/resend/email`, requestOptions)
          .then((response) => response.text())
          .then((result) => {
            console.log(result)
    
              result=JSON.parse(result);
              if(result.status==200){
               alert(result.message);
                setResponseMessage(result.message)
              }
              else
              {
                setResponseMessage(result.message)
              }
          })
          .catch((error) => {console.log("error", error);});
    
      };
  return (
    <section className="h-100 gradient-form" style={{ backgroundColor: '#eee' }}>
    <div className="container py-5 h-100">
      <div className="row d-flex justify-content-center align-items-center h-100">
        <div className="col-xl-10">
          <div className="card rounded-3 text-black">
            <div className="row g-0">
              <div className="col-md-6" >
                <div className="text-center my-auto" style={{height:'100%',display:'flex',alignItems:"center"}}>
                  <img
                    src="/logo.png"
                    alt="logo"
                    style={{ width: '400px' }}
                    className='text-center'
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="card-body p-md-5 mx-md-4">

                  <form onSubmit={handleSubmit}>
                    <p className='text-center text-danger text-blod'>Kindly enter the verification code to confirm your email.</p>
                    {/* Display the response message */}
                    {responseMessage && (
                      <p className="text-center text-danger">{responseMessage}</p>
                    )}
                    <div className="form-outline mb-4">
                      <label className="form-label" htmlFor="form2Example11">
                        Verification Code
                      </label>
                      <input
                        type="text"
                        id="form2Example11"
                        className="form-control"
                        placeholder="000000"
                        value={code}
                        onChange={handleCodeChange}
                        required
                      />
                    </div>
                   
                    <div className="text-center pt-1 mb-5 pb-1">
                    {!submit &&(<button
                      className="btn bg-brand px-4 btn_hover gradient-custom-2 mb-3"
                      type="submit"
                    >
                      Send
                    </button>)}
                    {submit &&(<button
                      className="btn bg-brand px-4 btn_hover gradient-custom-2 mb-3"
                      type="button"
                    >
                    Send 
                    <span class="spinner-border spinner-border-sm  mx-3" role="status">
                    </span>
                    </button>)}
                      
                      &nbsp;
                      &nbsp;
                      <Link className="text-muted "  id='forget_password' onClick={ResendEmail}>
                        Resend Email
                      </Link>
                     
                    </div>
                    
                  </form>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>  )
}

export default VerifyEmail